import { render, staticRenderFns } from "./heziShop3.vue?vue&type=template&id=63e1ccb2&scoped=true&"
import script from "./heziShop3.vue?vue&type=script&lang=js&"
export * from "./heziShop3.vue?vue&type=script&lang=js&"
import style0 from "./heziShop3.vue?vue&type=style&index=0&id=63e1ccb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1ccb2",
  null
  
)

export default component.exports